export const CLAIM = '@@claims/CLAIM';



// WEBPACK FOOTER //
// ./src/app/Claims/actionTypes.js